import { Option } from '@/common/types/option'
import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const missionStatusOptions: Option[] = [
  { label: 'Ativa', value: 'active' },
  { label: 'Inativa', value: 'inactive' },
]

export const missionTypeOptions: Option[] = [
  { label: 'Tcard', value: 'tcard' },
  { label: 'Estabelecimento', value: 'establishment' },
]

export const missionLoyaltyOptions: Option[] = [
  { label: 'Indiferente', value: 'indifferent' },
  { label: 'Bronze', value: 'bronze' },
  { label: 'Prata', value: 'silver' },
  { label: 'Ouro', value: 'gold' },
  { label: 'Platina', value: 'platinum' }, 
]

export const missionValidityFilterOptions: Option[] = [
  { label: 'Todas', value: '' },
  { label: 'Atuais', value: 'current' },
  { label: 'Futuras', value: 'upcoming' },
  { label: 'Expiradas', value: 'expired' },
]

export const missionMaxTimesOptions: Option[] = Array.from({ length: 10 }).map((_, index) => ({
  label: `${index + 1}x`,
  value: String(index + 1),
}))

export const missionStatusStrategy = optionsToStrategy(missionStatusOptions);